<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Zone'
}
</script>

<style scoped>
</style>
